var map = {
	"./0.png": 1345,
	"./0key.png": 608,
	"./1.png": 609,
	"./10.png": 1346,
	"./10key.png": 610,
	"./11.png": 1347,
	"./11key.png": 611,
	"./12.png": 1348,
	"./12key.png": 612,
	"./1key.png": 613,
	"./2.png": 1349,
	"./2key.png": 614,
	"./3.png": 1350,
	"./3key.png": 615,
	"./4.png": 1351,
	"./4key.png": 616,
	"./5.png": 1352,
	"./5key.png": 617,
	"./6.png": 1353,
	"./6key.png": 618,
	"./7.png": 1354,
	"./7key.png": 619,
	"./8.png": 1355,
	"./8key.png": 620,
	"./9.png": 1356,
	"./9key.png": 621,
	"./key-icon.png": 1357
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;



//////////////////
// WEBPACK FOOTER
// ./js/img/map ^\.\/.*\.png$
// module id = 623
// module chunks = 0